import ActionDialog from './src/ActionDialog';

export default ActionDialog;
